import { CompareOffersButton } from '@/components/compare-offers-button';
import { isSidebarCompareOpen } from '@/states/is-sidebar-compare-open.state';
import { useSetAtom } from 'jotai';

function AnalyzeButton({ showTooltip }: { showTooltip?: boolean }) {
  const setIsCompareSidebarOpen = useSetAtom(isSidebarCompareOpen);

  return (
    <CompareOffersButton
      onClick={() => setIsCompareSidebarOpen(true)}
      showTooltip={showTooltip}
    />
  );
}

export default AnalyzeButton;
